import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="M18.9998 9.5C18.9998 14.4675 14.9674 18.5 9.99985 18.5C5.03232 18.5 0.941406 14.526 0.941406 9.5C0.941406 4.53247 4.97387 0.5 9.94141 0.5C14.9089 0.5 18.9998 4.53247 18.9998 9.5Z"
      fill="#37BD95"
    />
    <path
      d="M8.3041 14.1757L4.33008 10.2017L5.67423 8.85754L8.3041 11.4874L14.2651 5.52637L15.6093 6.87052L8.3041 14.1757Z"
      fill="white"
    />
  </svg>,
  "CheckCircle"
);
